import React from "react";
import { observer } from "mobx-react-lite";
import { Tabs, Tab, Button, Icon, Text } from "@blueprintjs/core";
import { IconNames } from '@blueprintjs/icons';
import { getFonts, saveFonts, deleteFont } from "../config/api";

export const TextPanel = observer(({ store }) => {
    const [ fonts, setFonts ] = React.useState([]);
    const [ tabId, setTabId ] = React.useState("Text");
    const [ isUploading, setUploading ] = React.useState(false);

    const load = async () => {
        const fonts = await getFonts();
        setFonts(fonts);

        fonts.forEach((font) => {
            store.addFont({
                fontFamily: font.name,
                url: font.url
            })

            setTimeout(() => {
                store.loadFont(font.name)
            }, 150)
        })
    };

    const handleFileInput = async (e) => {
        const { target } = e;
        setUploading(true);
        for (const file of target.files) {
            await saveFonts(file);
        }
        await load();
        setUploading(false);
        target.value = null;
    };

    React.useEffect(() => {
        load();
    }, []);

    const headings = {
        h1: {
            type: "text",
            width: 540,
            height: 93,
            fontSize: 76,
            fill: "black",
            text: "hello",
        },
        h2: {
            type: "text",
            width: 540,
            height: 54,
            fontSize: 44,
            fill: "black",
            text: "hello",
        },
        h3: {
            type: "text",
            width: 540,
            height: 37,
            fontSize: 30,
            fill: "black",
            text: "hello",
        },
    };

    const handleNavbarTabChange = (tabId) => setTabId(tabId);
    const handleClick = (id) => {
        const heading = headings[id];
        heading.x = store.width / 2 - heading.width / 2;
        heading.y = store.height / 2 - heading.height / 2;

        store.activePage.addElement(heading);
    };
    const handleRemoveFont = async (name, url) => {
        console.log('remove font')

        const filename = url.split('/').pop()
        deleteFont(filename)

        store.removeFont(name)

        const fonts = await getFonts();
        setFonts(fonts);
    }

    return (
        <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <Tabs
                fill={false}
                large={true}
                animate={true}
                vertical={false}
                onChange={handleNavbarTabChange}
                selectedTabId={tabId}
                style={{ height: "100%", display: "flex", flexDirection: "column" }}
            >
                <Tab
                    id="Text"
                    title="Text"
                    style={{
                        height: "calc(100% - 40px)",
                        display: "flex",
                        flexDirection: "column",
                    }}
                    panel={
                        <>
                            <Button
                                id="h1"
                                onClick={() => handleClick("h1")}
                                minimal={true}
                                style={{
                                    fontFamily: "Roboto",
                                    fontSize: "25px",
                                    marginBottom: "5px",
                                    width: "100%",
                                }}
                            >
                                Create header
                            </Button>
                            <Button
                                id="h2"
                                onClick={() => handleClick("h2")}
                                minimal={true}
                                style={{
                                    fontFamily: "Roboto",
                                    fontSize: "18px",
                                    marginBottom: "5px",
                                    width: "100%",
                                }}
                            >
                                Create sub header
                            </Button>
                            <Button
                                id="h3"
                                onClick={() => handleClick("h3")}
                                minimal={true}
                                style={{
                                    fontFamily: "Roboto",
                                    fontSize: "14px",
                                    marginBottom: "5px",
                                    width: "100%",
                                }}
                            >
                                Create body text
                            </Button>
                        </>
                    }
                />

                <Tab
                    id="Fonts"
                    title="Fonts"
                    style={{
                        height: "calc(100% - 40px)",
                        display: "flex",
                        flexDirection: "column",
                    }}
                    panel={
                        <>
                            <label htmlFor="input-file">
                                <Button
                                    icon="upload"
                                    style={{ width: "100%" }}
                                    onClick={() => {
                                        document.querySelector("#input-file")?.click();
                                    }}
                                    loading={isUploading}
                                >
                                    Upload font
                                </Button>
                                <input
                                    type="file"
                                    id="input-file"
                                    style={{ display: "none" }}
                                    onChange={handleFileInput}
                                    multiple
                                />
                            </label>
                            <div>
                                {fonts.map(({ name, url }, i) => (
                                    <Button
                                        icon={<Icon icon={IconNames.TRASH}/>}
                                        alignText="center"
                                        minimal="true"
                                        key={i}
                                        style={{ width: "100%", marginBottom: "20px" }}
                                        onClick={() => handleRemoveFont(name, url)}
                                    >
                                        <Text style={{
                                            fontSize: "1.1rem",
                                            wordWrap: "break-word",
                                            fontFamily: name,
                                            maxWidth: "250px"
                                        }}
                                              tagName="div" ellipsize="true">
                                            {name}
                                        </Text>
                                    </Button>
                                ))}
                            </div>
                        </>
                    }
                />
            </Tabs>
        </div>
    );
});
